import React from 'react';
import { Modal } from 'react-bootstrap';
import '../../../assets/css/dashboard.css';
import Form from '../forms/addDepartment/DepartmentContainer';

const AddDepartment = (props) => {
	return (
		<div>
			<Modal
				show={props.show}
				onHide={props.onHide}
				size="md"
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<h5 className="text-grey">Add a Department</h5>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form refetch={props.refetch} />
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default AddDepartment;
